import { render, staticRenderFns } from "./MoneyInput.vue?vue&type=template&id=45e04a78&"
import script from "./MoneyInput.vue?vue&type=script&lang=ts&"
export * from "./MoneyInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports